import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function createDateRangeValidator() {
  return (form: AbstractControl): ValidationErrors | null => {
    const start: Date | null = form.get("startTime")?.value ? new Date(form.get("startTime")?.value) : null;
    const end: Date | null = form.get("endTime")?.value ? new Date(form.get("endTime")?.value) : null;
    if (start && end) {
      const isRangeValid = (end.getTime() - start.getTime() > 0);
      if(!isRangeValid){
        form.get("endTime")?.setErrors({ dateRange: true });
      }
      return isRangeValid ? null : {dateRange: true};
    }

    return null;
  }
}
export function validateSum() {
  return (form: AbstractControl): ValidationErrors | null => {
    const paymentType: number = +form.get("paymentType")?.value;
    if(!paymentType){
      return null;
    }

    const val = (name: string): number => +(form.get(name)?.value || 0);
    const price = val('price');

    let sum = 0;

    if(paymentType === 1){
      sum = val('cash');
    } else if(paymentType === 2){
      sum = val('card');
    } else if(paymentType === 3){
      sum = val('cash') + val('card');
    } else if(paymentType === 4){
      // Minutes-only payment — validated separately via min/max on the minutes control
      return null;
    } else if(paymentType === 5){
      sum = val('balance');
    } else if(paymentType === 6){
      sum = val('barter');
    } else if(paymentType === 7){
      sum = val('cash') + val('card') + val('consignation');
    } else if(paymentType === 8){
      sum = val('bankTransfer');
    } else if(paymentType === 9){
      sum = val('cash') + val('card') + val('balance') + val('bankTransfer');
    } else {
      return null;
    }

    return sum === price ? null : {totalPrice: true};
  }
}
